<template>
    <div id="reasons-for-attention" class="rel">
        <b-modal v-model="showModal" hide-footer size="xl" centered ref="modal-serv" scrollable :title="titleModal">
            <form id="formCrud" class="formCrud">
                <div class="row">
                    <div class="col-md-6 col-xl-4">
                        <input placeholder="Razon de la atención" type="text" class="al-inputs required scr-input"
                               name="razon" id="razon" v-model="reason.name" data-name-input="Razon de la atención"/>
                        <label for="razon" class="scr-supertext scr-extra">Razon de la atención</label>
                    </div>
                    <div class="col col-xl-3">
                        <select v-model="reason.status" data-select="on" data-name-input="Selecciona un Status" id="">
                            <option :value="0">Seleccione un Status</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Inactivo</option>
                        </select>
                    </div>
                    <div class="col-12 col-xl-2">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                                tituloBtn
                            }}
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="col-md-2">
                        <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                tituloBtn
                            }}
                        </button>
                    </div>
                </div>
                <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :items="reasons"
                         show-empty :filter="filter">
                    <template #head(acciones)="{item}">
                        <i class="fa-solid fa-gear"></i>
                    </template>
                    <template #empty="scope">
                        <h4 class="emptyRow">
                            No hay datos para mostrar.
                        </h4>
                    </template>
                    <template #cell(razon)="{item}">
                        <span>{{ item.name }}</span>
                    </template>
                    <template #cell(status)="{item}">
                        <span v-if="item.status===1" class="badge rounded-pill text-bg-success"> Activo</span>
                        <span v-if="item.status===2" class="badge rounded-pill text-bg-danger"> Inactivo</span>
                    </template>
                    <template #cell(acciones)="{item}">
                        <div class="dropdown">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-cogs"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="javascript:void(0)"
                                   v-on:click="updateReg(item)">Editar</a>
                                <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                            </div>
                        </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Cargando...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
        </main>
    </div>
</template>
<script>

import {myMixins} from "../mixins/myMixins";
import {reasonForAttentionsService} from "../../Services/ReasonForAttention.service";

export default {
    name: "ReasonForAttention",
    mixins: [myMixins],
    data() {
        return {
            filter: null,
            isBusy: false,
            reason: {
                id: '',
                name: '',
                status: 0,
            },
            fields: [
                {key: "razon"},
                {key: "status"},
                {key: "acciones"}
            ],
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            modificar: false,
            modal: 0,
            tituloModal: '',
            reasons: [],
            loading: true,
            myTableFlag: false,
            tituloBtn: 'Agregar',
        }
    },
    methods: {
        updateReg(data = {}) {
            this.modal = 1
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.reason = data;
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async onClickDelete(id) {
            let resp = '';
            resp = await reasonForAttentionsService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async index() {
            this.isBusy = true;
            this.reasons = await reasonForAttentionsService.getMany();
            this.isBusy = false;
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formCrud');
            //actualizando
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await reasonForAttentionsService.updateOne(this.reason.id, this.reason);
                } else {
                    resp = await reasonForAttentionsService.saveOne(this.reason);
                }
                this.disableSubmitBtn(false);
            }
            this.getAlert(resp.process);
            this.setEmpty();
            await this.index();
            this.modificar = false;
        },
        setEmpty() {
            this.reason = {
                id: '',
                name: '',
                status: 0,
            }
        }
    },
    mounted() {
        //console.log('env = ' + process.env.MIX_BASE_URL_JS);
        this.index();
    }
}
</script>

<style scoped>
form select {
    margin: 0 !important;
}
</style>
